import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
})

const optionStep = [
    { value: "0", label: "ساختمان" },
    { value: "1", label: "اثاثیه" },
    { value: "2", label: "ساختمان و اثاثیه" },
    { value: "3", label: "فیلد اضافی" },
    { value: "4", label: "فیلد اضافی(بانک صنعت معدن)" },
]

class ChangeFireBsmCoverages extends Component {
    cookies = new Cookies()
    constructor(props) {
        super(props)
        this.state = {
            redirect: false,
            errstr: "",
            errstatus: false,
            okstatus: false,
            requestinfos: [],
            agentInfofilter: [],
            rowsPerPage: 10,
            page: 0,
            coverage_id: "",
            coverage_name: "",

            coverage_desc: "",
            selectedCalculate: optionStep[2],
            coverage_extrafield: "",
            orderBy: "coverage_id",
            order: "desc",
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            newCoverage: true,
        }
    }

    handleChangeCoverageName = (event) => {
        this.setState({ coverage_name: event.target.value })
    }
    handleChangeCoverageId = (event) => {
        this.setState({ coverage_id: event })
    }

    handleChangeCoverageDesc = (event) => {
        this.setState({ coverage_desc: event.target.value })
    }

    handleChangeCoverageExtrafield = (event) => {
        if (event.target.checked) {
            this.setState({ coverage_extrafield: "1" })
        } else {
            this.setState({ coverage_extrafield: "0" })
        }
    }

    handleClickcloseTasckBar = (event) => {
        this.setState({ showSnack: false })
    }

    handleSelectRows = (row2) => {
        this.setState(
            {
                coverage_id: row2.coverage_id,
                coverage_name: row2.coverage_name,
                coverage_desc: row2.coverage_desc,
                coverage_extrafield: row2.coverage_extrafield,
                selectedCalculate: optionStep[row2.coverage_calculat_id],
                newCoverage: false,
            },
            () => {}
        )
    }

    newCoverage = (event) => {
        this.setState({
            coverage_id: "",
            coverage_name: "",
            coverage_desc: "",
            coverage_extrafield: "0",
            selectedCalculate: optionStep[2],
            newCoverage: true,
        })
    }

    handleCalculate = (selectedCalculate) => {
        this.setState({ selectedCalculate: selectedCalculate })
    }

    componentDidMount() {
        if (this.cookies.get("employee_token_str")) {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    if (arr.result === "ok") {
                        self.getCoverage()
                    } else if (arr.result === "error") {
                        self.setState({ redirect: true })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "checkemployeelogin")

            xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ redirect: true })
        }
    }

    getCoverage() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_coverage")

        xhttp.open("POST", `${constants.BASE_URL}/FireIndustrial`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    saveNewCoverage = () => {
        const {
            selectedCalculate,
            coverage_id,
            coverage_name,
            coverage_desc,
            coverage_extrafield,
        } = this.state
        if (coverage_id != "" && coverage_name != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        //self.setState({ redirect: true })
                        self.getCoverage()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "add_coverages")
            fd.append("coverage_id", coverage_id)
            fd.append("coverage_name", coverage_name)
            console.log(coverage_desc)
            fd.append("coverage_desc", coverage_desc)
            fd.append("coverage_extrafield", coverage_extrafield)
            fd.append("coverage_calculat_id", selectedCalculate.value)

            xhttp.open("POST", `${constants.BASE_URL}/FireIndustrial`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات پوشش اضافی  را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    deleteCoverage = () => {
        const { coverage_id } = this.state

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                    self.newCoverage()
                    self.getCoverage()
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "delete_coverage")
        fd.append("coverage_id", coverage_id)

        xhttp.open("POST", `${constants.BASE_URL}/FireIndustrial`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    changeCoverage = () => {
        const {
            selectedCalculate,
            coverage_id,
            coverage_name,
            coverage_desc,
            coverage_extrafield,
        } = this.state
        if (coverage_id != "" && coverage_name != "") {
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    var arr = JSON.parse(this.responseText)
                    console.log(arr)
                    if (arr.result === "ok") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        //self.setState({ redirect: true })
                        self.getCoverage()
                    } else if (arr.result === "error") {
                        self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    }
                    self.props.props.props.dispatch({
                        type: "WITEHIDE",
                    })
                }
            }
            var fd = new FormData()
            fd.append("command", "modify_coverages")
            fd.append("coverage_id", coverage_id)
            fd.append("coverage_name", coverage_name)
            fd.append("coverage_desc", coverage_desc)
            fd.append("coverage_extrafield", coverage_extrafield)
            fd.append("coverage_calculat_id", selectedCalculate.value)

            xhttp.open("POST", `${constants.BASE_URL}/FireIndustrial`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
        } else {
            this.setState({ snackstr: "لطفا مشخصات پوشش اضافی  را وارد نمایید", showSnack: true, snackMode: "error" })
        }
    }

    createSortHandler = (field) => {
        if (this.state.orderBy === field) {
            if (this.state.order === "asc") {
                this.setState({ order: "desc" })
            } else {
                this.setState({ order: "asc" })
            }
        } else {
            this.setState({ orderBy: field, order: "asc" })
        }
        var arraytemp = [],
            i,
            j,
            temp,
            a,
            b
        arraytemp = this.state.agentInfofilter
        for (i = 0; i < arraytemp.length; i++) {
            for (j = 0; j < arraytemp.length - 1; j++) {
                a = arraytemp[j]
                b = arraytemp[j + 1]
                if (a[field] < b[field] && this.state.order === "asc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                } else if (a[field] > b[field] && this.state.order === "desc") {
                    temp = arraytemp[j]
                    arraytemp[j] = arraytemp[j + 1]
                    arraytemp[j + 1] = temp
                }
            }
        }
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }

    render() {
        const { classes } = this.props
        const {
            selectedCalculate,
            agentPermision,
            snackMode,
            snackstr,
            showSnack,
            newCoverage,
            coverage_id,
            coverage_name,
            coverage_desc,
            coverage_extrafield,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            rowsPerPage,
            page,
        } = this.state
        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container component="main" maxWidth="lg">
                                <Paper elevation={4} className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}></Grid>

                                        <Grid item xs={6}>
                                            <Typography align="center" variant="h7">
                                                <FloatingLabelInput
                                                    type="number"
                                                    placeholder="آی دی پوشش اضافی "
                                                    handleInputt={this.handleChangeCoverageId}
                                                    value={coverage_id}
                                                />
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                placeholder="پوشش اضافی  "
                                                handleInputt={this.handleChangeCoverageName}
                                                value={coverage_name}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <FloatingLabelInput
                                                placeholder="توضیحات پوشش اضافی  "
                                                handleInputt={this.handleChangeCoverageDesc}
                                                value={coverage_desc}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <div style={{ width: "100%", textAlign: "center" }}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={
                                                                coverage_extrafield === "1" ? true : false
                                                            }
                                                            onChange={this.handleChangeCoverageExtrafield}
                                                            name="gilad"
                                                        />
                                                    }
                                                    label="فیلد اضافی"
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <div>
                                                <label className="on">فیلد مورد محاسبه</label>
                                                <Select
                                                    isSearchable={true}
                                                    className="adapter-txtsize"
                                                    placeholder={"فیلد مورد محاسبه"}
                                                    value={selectedCalculate}
                                                    onChange={this.handleCalculate}
                                                    options={optionStep}
                                                />
                                            </div>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>

                                        <Grid item xs={12}>
                                            {newCoverage ? (
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={(e) => {
                                                        this.saveNewCoverage()
                                                    }}
                                                >
                                                    {"ثبت پوشش اضافی  جدید "}
                                                </Button>
                                            ) : (
                                                <div style={{ width: "100%", textAlign: "right" }}>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.newCoverage}
                                                    >
                                                        {"پوشش اضافی  جدید"}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={(e) => {
                                                            this.changeCoverage()
                                                        }}
                                                    >
                                                        {"ثبت تغییرات"}
                                                    </Button>
                                                    {"          "}
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={(e) => {
                                                            this.deleteCoverage()
                                                        }}
                                                    >
                                                        {"حذف"}
                                                    </Button>
                                                </div>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Container>
                        </Grid>
                        <Grid item xs={12}>
                            <Container maxWidth="lg">
                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        key={"coverage_id"}
                                                        align={"center"}
                                                        style={{ minWidth: 20 }}
                                                        sortDirection={orderBy === "coverage_id" ? order : false}
                                                    >
                                                        {"آیدی پوشش اضافی  "}
                                                        <TableSortLabel
                                                            active={orderBy === "coverage_id"}
                                                            direction={
                                                                orderBy === "coverage_id" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("coverage_id")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"coverage_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"پوشش اضافی "}
                                                        <TableSortLabel
                                                            active={orderBy === "coverage_name"}
                                                            direction={
                                                                orderBy === "coverage_name" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("coverage_name")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"coverage_desc"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"توضیحات پوشش اضافی"}
                                                        <TableSortLabel
                                                            active={orderBy === "coverage_desc"}
                                                            direction={
                                                                orderBy === "coverage_desc" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("coverage_desc")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"coverage_calculat_id"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"فیلد مورد محاسبه"}
                                                        <TableSortLabel
                                                            active={orderBy === "coverage_calculat_id"}
                                                            direction={
                                                                orderBy === "coverage_calculat_id"
                                                                    ? order
                                                                    : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler(
                                                                    "coverage_calculat_id"
                                                                )
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                    <TableCell
                                                        key={"coverage_extrafield"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"فیلد اضافی"}
                                                        <TableSortLabel
                                                            active={orderBy === "coverage_extrafield"}
                                                            direction={
                                                                orderBy === "coverage_extrafield"
                                                                    ? order
                                                                    : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("coverage_extrafield")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {agentInfofilter
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["coverage_id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.handleSelectRows(row)
                                                                }}
                                                            >
                                                                <TableCell
                                                                    key={"coverage_id"}
                                                                    align={"center"}
                                                                >
                                                                    {row["coverage_id"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"coverage_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["coverage_name"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"coverage_desc"}
                                                                    align={"center"}
                                                                >
                                                                    {row["coverage_desc"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"coverage_calculat_id"}
                                                                    align={"center"}
                                                                >
                                                                    {
                                                                        optionStep[
                                                                            parseInt(
                                                                                row[
                                                                                    "coverage_calculat_id"
                                                                                    ]
                                                                            )
                                                                            ].label
                                                                    }
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"coverage_extrafield"}
                                                                    align={"center"}
                                                                >
                                                                    {row["coverage_extrafield"] === "0" ||
                                                                    row["coverage_extrafield"] === 0 ? (
                                                                        <Fab variant="extended">
                                                                            <VoiceOverOffIcon />
                                                                            {"بدون فیلد"}
                                                                        </Fab>
                                                                    ) : (
                                                                        <Fab
                                                                            variant="extended"
                                                                            style={{ background: "#44b700" }}
                                                                        >
                                                                            <RecordVoiceOverIcon />
                                                                            {"با فیلد اضافی"}
                                                                        </Fab>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={agentInfofilter.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>
                        </Grid>
                    </Grid>

                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                </div>
            )
        }
    }
}

export default withStyles(styles)(ChangeFireBsmCoverages)
